import axios from 'axios';
import { toast } from 'react-toastify';
// Create Axios instance
let navigateFunction = null;

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
};
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 300000,
});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('userAuthToken'); // Retrieve token from localStorage/session    
       // Define paths to exclude the token
       const excludePaths = ['/login', '/register','/reset-password'];
    
       // Check if the request URL matches any excluded path
       const isExcluded = excludePaths.some((path) =>
         config.url.endsWith(path)
       );       
       
       if (token && !isExcluded) {
         config.headers.Authorization = `Bearer ${token}`;
        //  config.headers.contentType = `json`;
         config.headers["ngrok-skip-browser-warning"] = "69420";
       }
       
       return config;
  },
  (error) => Promise.reject(error)
);
axiosInstance.interceptors.response.use(
  (response) => {

    if (response?.data?.message) {
      showToast(response.data.message, 'success');
    }
    return response;
  },
  (error) => {

    const currentPath = window.location.pathname;

    // Define your public page routes here
    const publicRoutes = ['/public'];

    // Check if current page is a public route
    const isOnPublicRoute = publicRoutes.some(route => currentPath.startsWith(route));
    console.log("isPublicRoute",isOnPublicRoute,error.response?.status);

    if (error.response?.status === 401 && !isOnPublicRoute) {
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/refresh`, {
        refresh: localStorage.getItem('refreshToken'),
      }).then((response) => {
        if (response.status === 200) {
          localStorage.setItem('userAuthToken', response?.data?.data?.access)
          localStorage.setItem('refreshToken', response?.data?.data?.refresh)
          window.location.reload()
        }
      }).catch((error) => {
        localStorage.removeItem('userAuthToken');
        localStorage.removeItem('refreshToken');
        // showToast("Session Expired, Please login", 'error');
        navigateFunction('/login')
      })
    } else {
      if(!isOnPublicRoute){   
        const errorMessage =
          error.response?.data?.details ||
          'Something went wrong!';
        showToast(errorMessage, 'error');
      }
    }
    return Promise.reject(error);
  }
);

// Toast function
const showToast = (message, type) => {
  if (type === 'success') {
    toast.success(message);
  } else if (type === 'error') {
    toast.error(message);
  }
};

export default axiosInstance;
